import Dexie from "dexie";
import { DB_NAME, STORE_DEFINITIONS, TABLES } from "./schema";

export class OceanLogixDexieDb extends Dexie {
  constructor(name = DB_NAME) {
    super(name);

    // Keep the previous schema declared so existing vessel installations upgrade safely.
    const versionTwoStores = Object.fromEntries(
      Object.entries(STORE_DEFINITIONS).filter(
        ([tableName]) => tableName !== TABLES.GENERATED_DOCUMENTS
      )
    );
    this.version(2).stores(versionTwoStores);
    this.version(3).stores(STORE_DEFINITIONS);

    this.organizations = this.table(TABLES.ORGANIZATIONS);
    this.vessels = this.table(TABLES.VESSELS);
    this.vesselParticulars = this.table(TABLES.VESSEL_PARTICULARS);
    this.tanks = this.table(TABLES.TANKS);
    this.voyages = this.table(TABLES.VOYAGES);
    this.trips = this.table(TABLES.TRIPS);
    this.tripCargo = this.table(TABLES.TRIP_CARGO);
    this.auditEntries = this.table(TABLES.AUDIT_ENTRIES);
    this.syncOperations = this.table(TABLES.SYNC_OPERATIONS);
    this.credentialPackages = this.table(TABLES.CREDENTIAL_PACKAGES);
    this.localSessions = this.table(TABLES.LOCAL_SESSIONS);
    this.vesselInstallations = this.table(TABLES.VESSEL_INSTALLATIONS);
    this.generatedDocuments = this.table(TABLES.GENERATED_DOCUMENTS);
  }
}

export const oceanLogixDexieDb = new OceanLogixDexieDb();
